import GA from '../GA';
import { find, isEmpty } from 'lodash';
import log from './console/log';

let _instance = null;

export default class GTMTracker {
  
  constructor (trackingId, appName, userData = {}) {
    const userGtmData = this.getUserGtmData(userData);
    const userUniqueId = `${userGtmData.userEmail}__${userGtmData.userId}`;
    GA.initialize({
      accessKey: trackingId,
      trackUIError: true,
      trackLoadPerformance: appName,
      gaOptions: {
        userId: btoa(userUniqueId),
      },
    });
    GA.setCustomDimension({ userId: userUniqueId });
    this.push('userAuthenticated', {
      userData: userGtmData,
    });
  }

  push = (eventType, eventObject = {}) => window.dataLayer.push({ ...eventObject, event: eventType })

  getUserGtmData = (userDetails = {}) => {
    try {
      const { user: userData, orgID, currentOrgDetails } = userDetails;
      const {
        basic_details: {
          base_country: orgBaseCountry = '',
          base_currency: orgBaseCurrency = '',
          base_language: orgBaseLanguage = '',
        } = {},
      } = currentOrgDetails || {};
      if (!isEmpty(userData)) {
        const {
          attributes: { USERNAME: userName, EMAIL: userEmail } = {},
          proxyOrgList = [],
          isCapUser,
          refID,
          orgName: userOrgName,
          type: userRole = '',
        } = userData;
        const { orgName } = find(proxyOrgList, { orgID }) || {
          orgName: userOrgName,
        };
        const gtmData = {
          isCapUser,
          orgId: orgID,
          orgName,
          userId: refID,
          userType: userRole,
          userName: userName?.value,
          userEmail: userEmail?.value,
          userRole,
          orgBaseCountry,
          orgBaseCurrency,
          orgBaseLanguage,
          domainName: userEmail?.value?.split('@').pop(),
        };
        return gtmData;
      }
    }
    catch(e) {
      log(e);
    }
    return {};
  };
}

GTMTracker.getInstance = (trackingId, appName, userDetails) => {
  if (_instance === null) {
    _instance = new GTMTracker(trackingId, appName, userDetails);
  }
  return _instance;
};